import { gql } from '@apollo/client';

export const ParagraphActivityPoiImagesFragment = gql`
  fragment ParagraphActivityPoiImages on ParagraphActivityPoiImages {
    id
    title
  }
`;
